const baseUrl = process.env.API_ROOT || '';
const baseUrlMe = process.env.API_ROOTS || '';
export default {

	// 微信分享
	"getAccessToken": baseUrl + "wechat/getAccessToken", // 获取accessToken
	"getJsapiTicket": baseUrl + "wechat/getJsapiTicket", // 获取jsapi_ticket(暂时用不到)
	"getSignature": baseUrl + "wechat/getSignature", // 获取signature(暂时用不到)
	"handler": baseUrl + "wechat/handler", // 校验信息是否是从微信服务器发出，处理消息(暂时用不到)

	//刷新token接口(匿名)
	"hiddenToken": baseUrlMe + "api/user/token/000000",

	//获取短信的接口
	"smsMsg" :  baseUrlMe+ "api/sms/msg",

	//登入接口
	"smsAutH5" : baseUrlMe+ "api/user/smsAuth_h5",

	"answerSave": baseUrl + "api/cd/answer/save",  //保存答案
	"initialUserInfo": baseUrl + "api/cpUserInfo/initialUserInfo",  //用户初始化
	"shareSuccess": baseUrl + "api/cpUserInfo/shareSuccess",  //标记用户分享

	// 抽奖相关
	"draw_lottery": baseUrl + "api/cd/prize/lottery",  //- 抽取奖品
	"draw_myPrizeList": baseUrl + "api/cpPrizeRecord/myPrizeList",  //我的奖品列表
	"draw_PrizeList": baseUrl + "api/cd/prize/getPrizeAll",  //奖品列表

	// 获取用户地址
	"myAddress": baseUrl + "api/cpPrizeRecord/myAddress",  //我的地址
	"editMyAddress": baseUrl + "api/cpPrizeRecord/modifyAddress",  //修改我的地址
	
	"getSysConfig": baseUrl + "api/cpSysConfig/getSysConfig",  //获取时间
	

}



// WEBPACK FOOTER //
// ./src/api/api.js